import classnames from 'classnames/bind'
import * as styles from './index.module.css'

const cx = classnames.bind(styles)

export default function ToolTip({ title, isVisible, isMultiline }) {
  return (
    <div className={cx(styles.wrapper, { isVisible, isMultiline })} dangerouslySetInnerHTML={{ __html: title }}>
      
    </div>
  )
}
